import { messagesFor } from '@rental/i18n'

/**
 * The rental terms as the customer reads them (CTR-1): the body's paragraphs
 * and the specific-approval paragraph (CTR-3), one rendering for the
 * contract on the signing screen, the customer's approval block and the
 * Owner's preview in Regole del contratto (OPS-1). The split is the one the
 * PDF uses too (a blank line between two paragraphs): what the Owner sees in
 * the preview is what the customer signs. The words are Italian for every
 * customer (Q-26), and say so to a screen reader.
 */
export function TermsBody({ body }: { body: string }) {
  // A paragraph repeated word for word is still its own paragraph: keyed by its words and its turn.
  const seen = new Map<string, number>()
  const keyed = body.split(/\n{2,}/).map((paragraph) => {
    const turn = (seen.get(paragraph) ?? 0) + 1
    seen.set(paragraph, turn)
    return { key: `${turn}:${paragraph}`, paragraph }
  })
  return (
    <>
      {keyed.map(({ key, paragraph }) => (
        <p key={key} lang="it" className="whitespace-pre-line">
          {paragraph}
        </p>
      ))}
    </>
  )
}

/** The specific-approval heading and paragraph, as the customer reads them before the second signature. */
export function TermsApproval({ text }: { text: string }) {
  return (
    <>
      <h2 lang="it" className="text-xl">
        {messagesFor('it').contract.sections.approval}
      </h2>
      <p lang="it" className="whitespace-pre-line">
        {text}
      </p>
    </>
  )
}
